import { type ReactElement } from 'react';
import { type ArticleContent } from 'types/wellbeing';
import BulletsList from './BulletList';

interface BulletsContentProps {
  contentItem: ArticleContent;
}

const BulletsContent = ({ contentItem }: BulletsContentProps): ReactElement => (
  <div>{contentItem.items && <BulletsList bullets={contentItem.items} />}</div>
);

export default BulletsContent;
